var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenario-result-component"},[_c('div',{staticClass:"mb-4"},_vm._l((Object.entries(_vm.scenarioResults)),function(ref,index){
var title = ref[0];
var percent = ref[1];
return _c('div',{key:index,staticClass:"result-progress"},[_c('UiProgressBarComponent',{attrs:{"title":title,"percentage":percent}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }